import React, { useEffect, useState } from "react";

import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

import Sidebar from "./Sidebar/Sidebar";
import "./Pages.scss";
import Widgets from "./Widgets/Widgets";
import { useUserAuth } from "../context/userAuthContext";
import NavMobile from "./Sidebar/NavMobile";

const Home = () => {
  const navigate = useNavigate();

  const { logout, user } = useUserAuth();

  // const user = {
  //   displayName: "Jatin Poriya",
  //   email: "poriyajatin914@gmail.com",
  // };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (user == null) {
      navigate("/signup");
    }
  }, [user]);

  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Auto-close sidebar on route change
    setShow(false);
  }, [location.pathname]);

  return (
    <div className="page">
      <Sidebar
        handleLogout={handleLogout}
        user={user}
        show={show}
        setShow={setShow}
      />
      <NavMobile setShow={setShow} />
      <Outlet />
      <Widgets />
    </div>
  );
};

export default Home;
